import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import('../../view/index.vue')
  },
  {
    path:"/multiplex",
    name:"multiplex",
    component: () => import('../../view/multiplex.vue')
  },
  // 课程详情
  {
    path: "/detail/:courseId",
    name: "detailsPage",
    component: () => import('../../view/details-page.vue')
  },
  // 搜索页
  {
    path: "/search",
    name: "search",
    component: () => import('../../view/search.vue')
  },

  // 学习中心
  {
    path: "/learning",
    name: "learning",
    component: () => import('../../view/learning.vue')
  },
  // 全部问答
  {
    path: "/seekHelp",
    name: "seekHelp",
    component: () => import('../../view/seek-help.vue')
  },
  // 我的问答
  {
    path: "/myHelp",
    name: "myHelp",
    component: () => import('../../view/my-help.vue')
  },
  // 问答详情
  {
    path: "/alone",
    name: "alone",
    component: () => import('../../view/alone.vue')
  },
  // 学习路线列表页
  {
    path: "/scene",
    name: "scene",
    component: () => import('../../view/scene-list.vue')
  },
  // 学习路线详情页
  {
    path: "/sceneDetails",
    name: "sceneDetails",
    component: () => import('../../view/scene-details.vue')
  },
  // 关于我们
  {
    path: "/about",
    name: "about",
    component: () => import('../../view/about.vue')
  },
  {
    path: '*',
    mame: "404",
    component: () => import('../../view/404.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // scrollBehavior(to, from,savedPosition) {
  //   return new Promise((resolve, reject) => {
  //     setTimeout(() => {
  //       resolve({ x: 0, y: 0 })
  //     }, 200)
  //   })
  // }
})

export default router
